/**
 *
 * Asynchronously loads the component for Video
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Video = lazyLoad(
  () => import('./index'),
  module => module.Video,
);
